<ng-template pTemplate="header">
  <span class="text-xl font-bold">{{ question_title }}</span>
</ng-template>

<div>
  <form [formGroup]="frmFilterContactHistory">
    <div class="grid">
      <div class="col md:col-3">
        <p-calendar
          [firstDayOfWeek]="1"
          dateFormat="dd/mm/yy"
          formControlName="rangeDates"
          selectionMode="range"
          [readonlyInput]="true"
          styleClass="w-full"
          placeholder="Filtra per data..."
          [showClear]="true"
          appendTo="body"></p-calendar>
      </div>
      <div class="col md:col-3">
        <input
          pInputText
          formControlName="related_contact_first_name"
          placeholder="Filtra per nome contatto..."
          ngClass="w-full" />
      </div>
      <div class="col md:col-3">
        <input
          pInputText
          formControlName="related_contact_last_name"
          placeholder="Filtra per cognome contatto..."
          ngClass="w-full" />
      </div>
      <div class="col md:col-3">
        <p-autoComplete
          [suggestions]="suggestedUsers"
          (completeMethod)="filterUsers($event)"
          field="fullName"
          id="id"
          class="flex-grow-1"
          dataKey="id"
          [emptyMessage]="'Nessun risultato trovato'"
          formControlName="related_user"
          [forceSelection]="true"
          [showClear]="true"
          styleClass="w-full"
          placeholder="Filtra per utente..."
          [showClear]="true"></p-autoComplete>
      </div>
      <div class="col-12">
        <p-button
          styleClass="butt w-full"
          icon="pi pi-filter-slash"
          (click)="clearAssetContactHisotry(dt3, $event)"
          pTooltip="Elimina filtri"
          tooltipPosition="top"></p-button>
      </div>
    </div>
  </form>
  <p-table
    [paginator]="true"
    [value]="asset_contact_history"
    #dt3
    [rows]="25"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="rowsPerPageOptions"
    [lazy]="true"
    [loading]="loading"
    (onLazyLoad)="loadAssetContactHistory($event)"
    [totalRecords]="totalRecordsContactsHistory"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Risultati {first} - {last} di {totalRecords} totali">
    <ng-template pTemplate="header">
      <tr class="tHead">
        <th>Data</th>
        <th>Contatto</th>
        <th>Utente</th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-a>
      <tr>
        <td>{{ a.created_on | date: 'dd/MM/yyyy HH:mm' }}</td>
        <td>
          {{
            a.related_registry_end_customer_contact?.last_name ||
              'Rientrato nel magazino: ' + selectedAsset?.related_warehouse?.name
          }}
          {{ a.related_registry_end_customer_contact?.name }}
        </td>
        <td>{{ a.related_user?.name || '-' }} {{ a.related_user?.last_name || '-' }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td
          colspan="3"
          class="text-center py-2">
          Nessun risultato.
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
